import React from "react";
import { useTranslation } from "../../i18n/TranslationProvider";

import { Col, Row, Form } from "react-bootstrap";

const TimeInput = ({ label, register, errors, className, disableStatus, checked }) => {
  const { t } = useTranslation();
  return (
    <Row className={className} style={{ padding: "0px 15px 15px 15px" }}>
      <Form.Label as="h6" style={{ width: "100%", margin: "10px 0px 20px 0px" }}>
        {label}
      </Form.Label>
      <Form.Group controlId="dayOfWeek">
        {[
          { label: t("timeinput.day.mon"), name: "monday" },
          { label: t("timeinput.day.tue"), name: "tuesday" },
          { label: t("timeinput.day.wed"), name: "wednesday" },
          { label: t("timeinput.day.thu"), name: "thursday" },
          { label: t("timeinput.day.fri"), name: "friday" },
          { label: t("timeinput.day.sat"), name: "saturday" },
          { label: t("timeinput.day.sun"), name: "sunday" },
        ].map((day) => (
          <Form.Check
            inline
            label={day.label}
            type="checkbox"
            name={day.name}
            id={day.name}
            ref={register}
            defaultChecked={checked}
            disabled={disableStatus}
            key={day.name}
            style={{ margin: "0 0.5rem" }}
          />
        ))}
        {errors.dayofweek && (
          <Form.Control.Feedback style={{ display: "block" }} type="invalid">
            {errors.dayofweek.message}
          </Form.Control.Feedback>
        )}
      </Form.Group>

      <Row style={{ width: "100%" }}>
        <Col xs={5} md={4}>
          <Form.Control
            placeholder="HH"
            type="number"
            ref={register}
            name="hour"
            aria-label="hour"
            isInvalid={errors.hour}
            disabled={disableStatus}
          />
        </Col>
        <Col xs={5} md={4}>
          <Form.Control
            as="select"
            aria-label="partOfDay"
            ref={register}
            name="partOfDay"
            isInvalid={errors.partOfDay}
            disabled={disableStatus}
          >
            <option value="AM">AM</option>
            <option value="PM">PM</option>
          </Form.Control>
        </Col>
      </Row>
      {errors.hour && (
        <Form.Control.Feedback style={{ display: "block" }} type="invalid">
          {errors.hour.message}
        </Form.Control.Feedback>
      )}
    </Row>
  );
};

export default TimeInput;